import { useEffect } from "react";
import { Link } from "react-router-dom";
import icon from "./assets/hanzi-blitz/icon.jpg";
import study from "./assets/hanzi-blitz/study.jpg";
import feedback from "./assets/hanzi-blitz/feedback.jpg";
import progress from "./assets/hanzi-blitz/progress.jpg";
import "./hanziBlitz.css";

const APP_STORE_URL = "https://apps.apple.com/us/app/hanzi-blitz/id6803297030";

export default function HanziBlitzPage() {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute("content");
    document.title = "Hanzi Blitz — Chinese & Kanji Practice";
    description?.setAttribute("content", "Learn Chinese vocabulary and Japanese kanji with focused practice and adaptive review. Free on iPhone, fully offline, with no accounts or ads.");
    return () => {
      document.title = previousTitle;
      if (previousDescription !== null && previousDescription !== undefined) {
        description?.setAttribute("content", previousDescription);
      } else {
        description?.removeAttribute("content");
      }
    };
  }, []);

  return (
    <main className="hanziBlitzPage">
      <div className="hanziBlitzShell">
        <nav className="hanziBlitzNav" aria-label="Hanzi Blitz navigation">
          <Link to="/">← Home</Link>
          <Link to="/hanzi-blitz/privacy">Privacy &amp; support</Link>
        </nav>

        <section className="hanziBlitzHero" aria-labelledby="hanzi-blitz-title">
          <div>
            <div className="hanziBlitzBrand">
              <img src={icon} width="80" height="80" alt="Hanzi Blitz app icon" />
              <div>
                <p className="hanziBlitzEyebrow">Hanzi Blitz</p>
                <p>Chinese &amp; Japanese · iPhone</p>
              </div>
            </div>
            <h1 id="hanzi-blitz-title">One word closer.<br /><span>Every day.</span></h1>
            <p className="hanziBlitzIntro">
              Build recognition of Chinese vocabulary and Japanese kanji with
              focused practice and reviews that adapt as you learn.
            </p>
            <a className="hanziBlitzDownload" href={APP_STORE_URL}>
              Download on the App Store <span aria-hidden="true">↗</span>
            </a>
            <p className="hanziBlitzAvailability">Free · iPhone with iOS 17 or later</p>
          </div>
          <aside className="hanziBlitzTracks" aria-label="Two independent learning tracks">
            <div><strong>10,000</strong><span>frequency-ranked Chinese characters &amp; words</span></div>
            <div><strong>2,136</strong><span>Jōyō kanji with on’yomi &amp; kun’yomi readings</span></div>
            <p>Two tracks. Your own progress in each.</p>
          </aside>
        </section>

        <section className="hanziBlitzPractice" aria-labelledby="hanzi-practice-title">
          <div className="hanziBlitzSectionHeading">
            <p className="hanziBlitzEyebrow">A little practice. Lasting recognition.</p>
            <h2 id="hanzi-practice-title">Meet a word. Make it stick.</h2>
          </div>
          <div className="hanziBlitzScreens">
            <figure>
              <img src={study} alt="Hanzi Blitz study screen with a word and six answer choices" width="222" height="480" loading="lazy" />
              <figcaption><h3>Recognize</h3><p>Choose the pronunciation and meaning. Practice compound words character by character.</p></figcaption>
            </figure>
            <figure>
              <img src={feedback} alt="Hanzi Blitz answer feedback and dictionary explanation" width="222" height="480" loading="lazy" />
              <figcaption><h3>Understand</h3><p>Learn from mistakes with dictionary senses, examples, and Mandarin pronunciation.</p></figcaption>
            </figure>
            <figure>
              <img src={progress} alt="Hanzi Blitz learning and mastered-word statistics" width="222" height="480" loading="lazy" />
              <figcaption><h3>Remember</h3><p>Missed words return sooner. Track what you’re learning and what you’ve mastered.</p></figcaption>
            </figure>
          </div>
        </section>

        <section className="hanziBlitzOffline" aria-labelledby="hanzi-offline-title">
          <div>
            <h2 id="hanzi-offline-title">Your learning stays with you.</h2>
            <p>Fully offline. No accounts, ads, analytics, or tracking. All study progress stays on your iPhone.</p>
          </div>
          <a className="hanziBlitzDownload" href={APP_STORE_URL}>Get Hanzi Blitz <span aria-hidden="true">↗</span></a>
        </section>

        <footer className="hanziBlitzFooter">
          <span>© 2026 Heng Quan</span>
          <Link to="/hanzi-blitz/privacy">Privacy policy &amp; support</Link>
        </footer>
      </div>
    </main>
  );
}
